// extracted by mini-css-extract-plugin
export default {"sidebarContainer":"Sidebar_sidebarContainer__EBaQJ","changeRequestButton":"Sidebar_changeRequestButton__QaHxa","logOutButton":"Sidebar_logOutButton__y3sy6"};